<script setup>
import CorrectsInTir from './CorrectsInTir.vue'
import { getFullScore, getDuplicateLose, getResult } from './filters'
import { SCORE_TYPES } from '../../../../utils/const'
import GalleryBox from '../../../../components/GalleryBox'

defineProps({
    tir: {
        type: Object,
        required: true
    },
    index: {
        default: null
    },
    showCheckBoxOptions: {
        type: Boolean,
        default: false
    }
})

function getAttaList(tir) {
    const attaList = []
    Array.isArray(tir.images) && tir.images.forEach(url => attaList.push(url))
    Array.isArray(tir.videos) && tir.videos.forEach(v => attaList.push({ src: v.url, thumb: v.thumbnail, type: 2 }))
    return attaList
}
</script>
<template>
    <div v-if="tir.id">
        <div class="mt8 w650 flex-between-center" v-if="tir.assessor">
            <span>评估人：</span>
            <span>{{ tir.assessor }}</span>
        </div>
        <div class="mt10 w650 flex-between-center" v-if="tir.evaTime">
            <span>评估时间：</span>
            <span>{{ tir.evaTime }}</span>
        </div>
        <div v-if="Number.isInteger(index)" class="taskName">
            {{ index + 1 }}、{{ tir.describle }}{{ getFullScore(tir) }}
            <span class="red">{{ getDuplicateLose(tir) }}</span>
        </div>
        <div v-if="showCheckBoxOptions && tir.type === 3 && Array.isArray(tir.options)" >
            <div v-for="(o, i) in tir.options" :key="i">
                <div class="result mt10">{{ o.name }}</div>
                <span class="fs20">{{ o.state===1 ? '☑' : '☐' }}</span><span class="mr20">符合</span>
                <span class="fs20">{{ o.state===0 ? '☒' : '☐' }}</span><span>不符合</span>
                <!-- <el-checkbox :checked="o.state===1" disabled>符合</el-checkbox>
                <el-checkbox :checked="o.state===0" class="cross-checkbox" disabled>不符合</el-checkbox> -->
            </div>
        </div>        
        <div v-else-if="tir.type != 9" class="result">
            结果：{{ getResult(tir) }}
            <span v-if="SCORE_TYPES.includes(tir.type) && Number(tir.fullScore) > 0">（{{ tir.score + "分" }}）</span>
        </div>
        <div v-if="tir.comment" class="describle">
            备注：{{ tir.comment }}
        </div>
        <div v-if="Array.isArray(tir.responsibleDepartmentNames) && tir.responsibleDepartmentNames.length" class="mt10">
            <el-tag v-for="(rdName, index) in tir.responsibleDepartmentNames" :key="index" class="mr10">{{ rdName }}</el-tag>
        </div>
        <GalleryBox class="mt10" :attaList="getAttaList(tir)" />
        <CorrectsInTir :tir="tir" />
    </div>
</template>
<style lang="less" scoped>
.taskName {
    text-align: justify;
    color: #000;
    font-weight: 500;
    padding-right: 35px;
    // font-size: 28px;
}
.result {
    // font-size: 28px;
    color: #428ff8;
    word-break: break-all;
    margin-top: 8px;
}
.describle {
    // font-size: 28px;
    color: #74879b;
    word-break: break-all;
    margin-top: 8px;
}
</style>